import React, { PureComponent } from 'react';
import styles from './index.css';

import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import ImgSlides from '../imgSlides';
import VideoBox from '../videobox';

const RightTwo = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
            show: PropTypes.bool,
        };
        render() {
            const { content } = this.props;
            const { images, videos } = content;

            return (
                <div id="box_02" className={styles.tab_box} style={{ display: this.props.show ? 'block' : 'none' }}>
                    <div className={`${styles.ggjs} ${styles.ggjs_w778}`}>
                        <div className={styles.cp_title}>
                            <img src={images.navImg} alt="" />
                        </div>
                        <ImgSlides content={images.images} />
                        <div className={styles.space70} />
                        <div className={styles.cp_title}>
                            <img src={videos.navImg} alt="" />
                        </div>
                        <p className={styles.mt15}> {videos.description} </p>
                        <VideoBox content={videos.videos} play={this.props.show} />
                    </div>
                </div>
            );
        }
    },
);

export { RightTwo };
export default RightTwo;
